import React from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialBox from '../../components/MaterialBox'
import { Grid } from '@mui/material'
import ProjectHeaderCard from './components/ProjectHeaderCard'
import BasicDetails from './components/BasicDetails'
import TaskChartCard from './components/TaskChartCard'
import TeamsCard from './components/TeamsCard'
import AttachmentsCard from './components/AttachmentsCard'

const DashboardProject = () => {
    return (
        <DashboardLayout>
            <MaterialBox padding={1}>

                <Grid container spacing={1} >
                    <Grid size={{ xs: 12, md: 12, lg: 12 }} >
                        <ProjectHeaderCard />
                    </Grid>
                </Grid>

                <Grid container spacing={1} mt={3}>
                    <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                        <BasicDetails />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                        <TaskChartCard />
                    </Grid>
                    <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                        <TeamsCard />
                    </Grid>
                </Grid>

                <Grid container spacing={1} mt={1}>
                    <Grid size={{ xs: 12, md: 3, lg: 3 }}>
                        <AttachmentsCard />
                    </Grid>

                </Grid>

            </MaterialBox>
        </DashboardLayout>
    )
}

export default DashboardProject